export const commercialSeasonalPage = {
  hero: {
    eyebrow: 'Commercial properties & HOA communities',
    title: 'Keep your property ready for the season.',
    intro:
      'From snow and ice management to parking-lot and construction-site care, find practical services for the business properties and communities you manage.',
    primary: { label: 'Discuss your property', href: '/contact' },
    image: 'https://codex.websiteforge.net/da-alexander-redesign-20261028/assets/service-commercial-20261029.png',
    alt: 'A snowplow clearing a commercial parking lot.',
  },
  winter: {
    eyebrow: 'Winter property care',
    title: 'Snow removal & salting for commercial and HOA properties.',
    text: 'Plan for the snow and ice around parking areas, roads and walkways. D.A. Alexander’s commercial snow services support business properties and homeowners association communities through winter conditions.',
    items: [
      'Snow plowing',
      'Sidewalk snow cleanup',
      'Road salt applications',
      'Walkway ice-melt application',
      'Loader services',
      'Snow hauling from the site',
    ],
  },
  support: {
    title: 'Care for paved areas and active sites.',
    groups: [
      {
        id: 'parking-lots-roads',
        title: 'Parking lots & roads',
        text: 'Keep commercial paved areas cared for with sweeping, cleaning and pavement maintenance services.',
        items: [
          'Power vacuum sweeping & cleaning',
          'Pavement maintenance & repairs',
          'Parking signs & striping',
          'Power washing',
        ],
      },
      {
        id: 'construction-sites',
        title: 'Construction sites',
        text: 'Support an active project with cleanup and sweeping for the site and surrounding roads.',
        items: [
          'Street sweeping',
          'Heavy debris scraping & cleanup',
          'Curb and exterior cleanup',
          'Silt fence and silt-sac maintenance',
        ],
      },
    ],
  },
  related: {
    title: 'Looking for ongoing landscape maintenance?',
    text: 'Explore commercial lawn and landscape care for business properties and HOA common areas.',
    link: { label: 'Commercial landscape care', href: '/commercial-landscape-care' },
  },
  closing: {
    title: 'Tell us about your property or site.',
    text: 'Share your location, the type of property you manage and the services you need. We’ll help you find the right place to start.',
    action: { label: 'Send a commercial-service inquiry', href: '/contact' },
    location: 'Based in Livonia. Serving southeast Michigan.',
  },
};
